import React from "react";
import Blockquote from "../MenuItems/Blockquote";
import RemoveFormatting from "../MenuItems/RemoveFormatting";
import HorizontalRule from "../MenuItems/HorizontalRule";

const Highlighters = ({ editor, disabled }) => {
	return (
		<>
			<div className={`editor-menu-box`}>
				<Blockquote
					onChange={() => editor.chain().focus().setBlockquote().run()}
					isActive={editor.isActive("blockquote")}
					isDisabled={
						disabled || !editor.can().chain().focus().setBlockquote().run()
					}
				/>
				<RemoveFormatting
					onClick={() =>
						editor.chain().focus().clearNodes().unsetAllMarks().run()
					}
					isDisabled={disabled}
				/>
				<HorizontalRule
					onClick={() => editor.chain().focus().setHorizontalRule().run()}
					isDisabled={disabled}
				/>
			</div>
		</>
	);
};

export default Highlighters;
